import { BaseApiSelector } from "@bornfight/aardvark";
import { ResourceType } from "enums/ResourceType";
import { AnswerJSONAModel } from "interfaces/jsona-models/AnswerJSONAModel";

export class AnswerSelector extends BaseApiSelector<AnswerJSONAModel> {
  constructor() {
    super(ResourceType.Answer);
  }
}
